<template>
  <div v-loading="quillLoading">
    <div :class="'editor editor' + i"></div>
    <el-upload :class="'quill-editor-upload quill-editor-upload' + i" drag style="display:none;" action :auto-upload="true"
      accept="image/png,image/jpeg,image/jpg" :http-request="quillUploadAction" :before-upload="quillUploadBefore"
      multiple>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>
  </div>
</template>

<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import OSS from 'ali-oss'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', ImageResize)
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'


let client = new OSS({
  region: 'oss-cn-beijing',
  accessKeySecret: 'mPTRYqVIIWC8XxSeZqKFMPtFMWMfb5', // AccessKeySecret 去你的阿里云上控制台上找
  accessKeyId: 'LTAIvBaMapD5qPW9', // AccessKeyId 去你的阿里云上控制台上找
  bucket: 'linkedln',
  endpoint: 'images.qilinpin.cn',
  cname: true,
  secure: true
})




export default {
  name: 'editor',
  props: {
    value: Object
  },
  data() {
    return {
      i: random_stringgg(8),
      quill: null,
      quillLoading: false,
      options: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean'],
              ['link', 'image']
            ],
            handlers: {
              'image': (value) => {
                debugger
                document.querySelector(`.${this.quill.container.parentElement.childNodes[2].classList[1]} input`).click()
              }
            }
          },
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          }
        },
        placeholder: '请输入内容'
      }
    }
  },
  computed: {

  },
  mounted() {
    let dom = this.$el.querySelector('.editor' + this.i)
    this.quill = new Quill(dom, this.options)
    this.quill.setContents(this.value)
    this.quill.on('text-change', () => {
      this.$emit('input', this.quill.getContents())
    })
  },
  methods: {
    random_string: function (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    random_number: function (len) {
      len = len || 32
      var chars = '123456789'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    quillUploadAction(e) {
      debugger
      let that = this
      let str = this.random_string(32)
      client.multipartUpload('upload/' + str + '.png', e.file, {
        progress: function (p) {
          that.loading = true;
          console.log('Progress: ' + p);
          that.p = p
        }
      }).then((res) => {
        console.log(res)
        let length = that.quill.getSelection().index
        // 插入图片 res.url为服务器返回的图片地址
        that.quill.insertEmbed(length, 'image', 'https://images.qilinpin.cn/' + res.name)
        // 调整光标到最后
        that.quill.setSelection(length + 1)
        that.quillLoading = false
      }).catch((err) => {
        that.loading = false
        console.log(err);
      });
    },
    quillUploadBefore() {
      this.quillLoading = true
    },
    quillUploadSuccess(response, file, fileList) {
      debugger
      if (response.code === 0) {
        let length = this.quill.getSelection().index
        // 插入图片 res.url为服务器返回的图片地址
        this.quill.insertEmbed(length, 'image', response.data)
        // 调整光标到最后
        this.quill.setSelection(length + 1)
      }
      this.quillLoading = false
    }
  }
}


function random_stringgg (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    }

</script>

<style>
.editor {
  line-height: normal !important;
  height: 400px;
}

.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
</style>

